import {useEffect,useState} from 'react';
import {api} from '../api';
import {Link} from '../ui/ScopedLink';
import {withBuildingScope} from '../ui/building-scope';
import {formatDateTime} from '../dates';
import {ErrorState,Loading} from '../ui/State';

type Row={id:string;title:string;status:string;development_id?:string;last_message_at:string};
type Page={building?:string;items:Row[];page:number;pageSize:number;total:number};

export function ConversationQueue({building,current}:{building:string|undefined;current:string}){
 const [open,setOpen]=useState(false),[data,setData]=useState<Page>(),[error,setError]=useState<unknown>();
 useEffect(()=>{
  if(!open)return;
  let active=true;setData(undefined);setError(undefined);
  void api<Page>(withBuildingScope('/api/communications/threads?page=1&pageSize=12',building)).then(value=>{
   if(!Array.isArray(value.items)||value.page!==1||value.pageSize!==12||building&&(value.building!==building||value.items.some(row=>row.development_id!==building)))throw Error('The conversation queue could not be confirmed in this scope.');
   if(active)setData(value);
  }).catch(value=>{if(active)setError(value)});
  return()=>{active=false};
 },[open,building]);
 return <details className="conversation-queue" onToggle={event=>setOpen(event.currentTarget.open)}>
  <summary>Queue</summary>{open&&(error?<ErrorState error={error}/>:!data?<Loading/>:<>
   <p>{data.total} conversations · first {data.items.length}</p><ul>{data.items.map(row=><li key={row.id}><Link aria-current={row.id===current?'page':undefined} to={withBuildingScope('/communications/threads/'+row.id,building)}><strong>{row.title}</strong><small>{row.status} · {formatDateTime(row.last_message_at)}</small></Link></li>)}</ul>
   <Link to={withBuildingScope('/communications',building)}>Full inbox</Link>
  </>)}
 </details>;
}
